import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchEngineerQueryVariables = Types.Exact<{
  filters: Types.MechanicFilters;
}>;


export type FetchEngineerQuery = { __typename?: 'Query', mechanics: { __typename?: 'MechanicsMechanicConnection', totalCount: number, pageInfo: { __typename?: 'MechanicsPageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ __typename?: 'MechanicsMechanicEdge', node: { __typename?: 'Mechanic', id: string, userId?: number | null, lastName?: string | null, firstName?: string | null, teams?: Array<Types.MechanicTeam> | null } }> } };

export type EngineerOptionFragment = { __typename?: 'Mechanic', id: string, userId?: number | null, lastName?: string | null, firstName?: string | null, teams?: Array<Types.MechanicTeam> | null };

export const EngineerOptionFragmentDoc = gql`
    fragment EngineerOption on Mechanic {
  id
  userId
  lastName
  firstName
  teams
}
    `;
export const FetchEngineerDocument = gql`
    query FetchEngineer($filters: MechanicFilters!) {
  mechanics(filters: $filters) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        ...EngineerOption
      }
    }
  }
}
    ${EngineerOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchEngineerGQL extends Apollo.Query<FetchEngineerQuery, FetchEngineerQueryVariables> {
    override document = FetchEngineerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }